import React from 'react';
import PlansV3 from '../Plans/Plans.v3';

const Enterprise = () => (
    <PlansV3 enterpriseOnly={true} />
);

export default Enterprise;

